import { jsx as _jsx } from "react/jsx-runtime";
import useIconProps from '../utils/use-icon-props';
import useStrokeWidth from '../utils/use-stroke-width';
const Wood = (props) => {
    const iconProps = useIconProps(props);
    const strokeWidth = useStrokeWidth(iconProps.width);
    return (_jsx("svg", Object.assign({}, iconProps, { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M16 30V18.8M16 18.8V13.2M16 18.8L21.6 16M23 9C23 5.13401 19.866 2 16 2C12.134 2 9.00002 5.13401 9.00002 9M11.8 9H9.7C5.4474 9 2 12.4474 2 16.7C2 20.9526 5.4474 24.4 9.7 24.4L22.3 24.4C26.5526 24.4 30 20.9526 30 16.7C30 12.6834 26.9246 9.38511 23 9.03144", stroke: "#2B2B2B", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default Wood;
